import React, { useState } from 'react';
import useTaskDrag from './useTaskDrag';
import TaskCard from './TaskCard';
import TaskView from './TaskView';
import { type TaskSummary } from '@/lib/types';

type TaskProps = {
  task: TaskSummary;
  disableDrag?: boolean;
};

const Task = ({ task, disableDrag }: TaskProps) => {
  const [isDragging, attachDragHandlingRef] = useTaskDrag(
    task,
    disableDrag ?? false,
  );
  const [open, setOpen] = useState(false);

  return (
    <>
      <TaskCard
        task={task}
        dragging={isDragging}
        onClick={() => setOpen(true)}
        ref={attachDragHandlingRef as React.Ref<HTMLButtonElement>}
      />
      {open && <TaskView task={task} onClose={() => setOpen(false)} />}
    </>
  );
};

export default Task;
